export const extractFilename = (path) => {
    if (!path) return "";
    const parts = String(path).split("/");
    return parts[parts.length - 1].replace(/\.[^/.]+$/, "");
};

const normalize3DFile = (file) => {
    if (!file) return { glb: null, html: null };
    if (typeof file === "string") return { glb: null, html: file };
    return {
        glb: file.glb || null,
        html: file.html || null,
    };
};

const normalizeModelPath = (path) =>
    String(path || "")
        .trim()
        .replace(/\\/g, "/")
        .replace(/\/{2,}/g, "/");

const buildModelKey = (model) =>
    `${model.type}|${model.format || ""}|${normalizeModelPath(model.path)}`;

export const collectAvailableModelsFromModelData = (modelData = {}) => {
    const models = [];
    const seen = new Set();

    const pushModel = (model) => {
        if (!model?.type || !model?.path) return;
        const key = buildModelKey(model);
        if (seen.has(key)) return;
        seen.add(key);
        models.push(model);
    };

    // Keep counting behavior aligned with MultipleModelViewer:
    // prefer one 3D variant per logical entry (glb first, then html).
    const main3d = normalize3DFile(modelData["3dfile"]);
    if (main3d.glb || main3d.html) {
        const path = main3d.glb || main3d.html;
        pushModel({ type: "3D", format: main3d.glb ? "glb" : "html", path });
    }

    (modelData.splitfiles || []).forEach((sf) => {
        const glb = sf?.glb || null;
        const html = sf?.html || sf?.file || null;
        const path = glb || html;
        if (!path) return;
        pushModel({ type: "3D", format: glb ? "glb" : "html", path });
    });

    (modelData.boms || []).forEach((bom) => {
        const threeD = normalize3DFile(bom?.["3dfile"]);
        if (threeD.glb || threeD.html) {
            const path = threeD.glb || threeD.html;
            pushModel({ type: "3D", format: threeD.glb ? "glb" : "html", path });
        }
    });

    if (modelData["2dfile"]) {
        pushModel({ type: "2D", format: "2d", path: modelData["2dfile"] });
    }

    (modelData.boms || []).forEach((bom) => {
        if (bom["2dfile"]) {
            pushModel({ type: "2D", format: "2d", path: bom["2dfile"] });
        }
    });

    return models;
};

export const countAvailableModelsFromModelData = (modelData = {}) =>
    collectAvailableModelsFromModelData(modelData).length;

export const selectBestModelFromModelData = (modelData = {}) => {
    const models = collectAvailableModelsFromModelData(modelData);
    if (!models.length) return null;
    const best = models[0];
    if (best.type === "2D") {
        return { type: "2D", path: best.path };
    }
    return { type: "3D", format: best.format, path: best.path };
};
